 
import _ from 'underscore'

import service from '../service/order'
import ORDERCONSTANT from '../constant/order'
import { json } from 'd3'

export default {
  getOrderList ({ commit }, query) {
    return new Promise((resolve, reject) => {
      return service.getOrderList(query).then(data => {
        if (_.isEmpty(data)) {
          resolve(data)
          commit(ORDERCONSTANT.ORDER_GET_ALL_EMPTY)
          return data
        }
        resolve(data)
        commit(ORDERCONSTANT.ORDER_GET_ALL_SUCCESS, data)
        return data
      }, e => {
        reject(e)
        commit(ORDERCONSTANT.ORDER_GET_ALL_ERROR, e)
      })
    })
  },
  getOrderDetail ({commit}, query) {
    return new Promise((resolve, reject) => {
      return service.getOrderDetail(query).then(data => {
        resolve(data)
        commit(ORDERCONSTANT.ORDER_GET_DETAIL_SUCCESS, data)
        return data
      }, e => {
        reject(e)
        commit(ORDERCONSTANT.ORDER_GET_DETAIL_ERROR, e)
      })
    })
  },
  cancelPayOrder ({commit}, query) {
    return new Promise((resolve, reject) => {
      return service.cancelPayOrder(query).then(data => {
        resolve(data)
        commit(ORDERCONSTANT.ORDER_CANCEL_SUCCESS, data)
        return data
      }, e => {
        reject(e)
        commit(ORDERCONSTANT.ORDER_CANCEL_ERROR, e)
      })
    })
  },
  confirmDelivery ({ commit }, query) {
    return new Promise((resolve, reject) => {
      return service.confirmDelivery(query).then(data => {
        resolve(data)
        commit(ORDERCONSTANT.DELIVERY_GET_CONFIRM_SUCCESS, data)
        return data
      }, e => {
        reject(e)
        commit(ORDERCONSTANT.DELIVERY_GET_CONFIRM_ERROR, e)
      })
    })
  },
  getRecommendByOrder ({ commit }, query) {
    return new Promise((resolve, reject) => {
      return service.getRecommendByOrder(query).then(data => {
        if (_.isEmpty(data.data)) {
          resolve(data)
          commit(ORDERCONSTANT.ORDER_GET_RECOMMEND_LIST_EMPTY)
          return data
        }
        resolve(data)
        commit(ORDERCONSTANT.ORDER_GET_RECOMMEND_LIST_SUCCESS, data)
        return data
      }, e => {
        reject(e)
        commit(ORDERCONSTANT.ORDER_GET_RECOMMEND_LIST_ERROR, e)
      })
    })
  },
  checkProductStatus ({ commit }, query) {
    return new Promise((resolve, reject) => {
      return service.checkProductStatus(query).then(data => {
        resolve(data)
        commit(ORDERCONSTANT.ORDER_CHECK_PRODUCT_STATUS_SUCCESS, data)
        return data
      }, e => {
        reject(e)
        commit(ORDERCONSTANT.ORDER_CHECK_PRODUCT_STATUS_ERROR, e)
      })
    })
  },
  refreshOrder ({ commit }, query) {
    return new Promise((resolve, reject) => {
      return service.refreshOrder(query).then(data => {
        resolve(data)
        return data
      }, e => {
        reject(e)
      })
    })
  },
  getDeliveryInfo ({ commit }, query) {
    return new Promise((resolve, reject) => {
      return service.getDeliveryInfo(query).then(data => {
        resolve(data)
        commit(ORDERCONSTANT.ORDER_GET_DELIVERY_SUCCESS, data)
        return data
      }, e => {
        reject(e)
        commit(ORDERCONSTANT.ORDER_GET_DELIVERY_ERROR, e)
      })
    })
  },
  getOrderListMore ({ commit }, query) {
    return new Promise((resolve, reject) => {
      return service.getOrderList(query).then(data => {
        if (_.isEmpty(data)) {
          resolve(data)
          // commit(ORDERCONSTANT.ORDER_GET_ALL_MORE_EMPTY)
          return data
        }
        resolve(data)
        commit(ORDERCONSTANT.ORDER_GET_ALL_MORE_SUCCESS, data)
        return data
      }, e => {
        reject(e)
        // commit(ORDERCONSTANT.ORDER_GET_ALL_MORE_ERROR, e)
      })
    })
  },
  getOrderListOld ({ commit }, query) {
    return new Promise((resolve, reject) => {
      return service.getOrderListOld(query).then(data => {
        if (_.isEmpty(data)) {
          resolve(data)
          commit(ORDERCONSTANT.ORDER_GET_ALL_EMPTY)
          return data
        }
        resolve(data)
        commit(ORDERCONSTANT.ORDER_GET_ALL_SUCCESS, data)
        return data
      }, e => {
        reject(e)
        commit(ORDERCONSTANT.ORDER_GET_ALL_ERROR, e)
      })
    })
  },
  getOrderListOldMore ({ commit }, query) {
    return new Promise((resolve, reject) => {
      return service.getOrderListOld(query).then(data => {
        if (_.isEmpty(data)) {
          resolve(data)
          commit(ORDERCONSTANT.ORDER_GET_ALL_MORE_EMPTY)
          return data
        }
        resolve(data)
        commit(ORDERCONSTANT.ORDER_GET_ALL_MORE_SUCCESS, data)
        return data
      }, e => {
        reject(e)
        commit(ORDERCONSTANT.ORDER_GET_ALL_MORE_ERROR, e)
      })
    })
  },
  getOrderDetailOld ({commit}, query) {
    return new Promise((resolve, reject) => {
      return service.getOrderDetailOld(query).then(data => {
        resolve(data)
        commit(ORDERCONSTANT.ORDER_OLD_GET_DETAIL_SUCCESS, data)
        return data
      }, e => {
        reject(e)
        commit(ORDERCONSTANT.ORDER_OLD_GET_DETAIL_ERROR, e)
      })
    })
  },
  getOrderSimple ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getOrderSimple(data).then(result => {
                resolve(result)
              commit(ORDERCONSTANT.ORDER_GETORDERSIMPLE_SUCCESS, result)
                return result
            }, e => {
                reject(e)
              commit(ORDERCONSTANT.ORDER_GETORDERSIMPLE_ERROR, e)
            })
        })
    },
  getUserInvoice ({commit}, orderId) {
      return new Promise((resolve, reject) => {
        return service.getUserInvoice(orderId).then(result => {
          resolve(result)
          commit(ORDERCONSTANT.ORDER_GET_USERINVOICE_SUCCESS, result)
          return result
        }, e => {
          reject(e)
          commit(ORDERCONSTANT.ORDER_GET_USERINVOICE_ERROR, e)
        })
      })
  },
  setOrderInvoice ({commit}, data) {
    return new Promise((resolve, reject) => {
      return service.setOrderInvoice(data).then(result => {
        resolve(result)
        commit(ORDERCONSTANT.ORDER_SET_ORDERINVOICE_SUCCESS, result)
        return result
      }, e => {
        reject(e)
        commit(ORDERCONSTANT.ORDER_SET_ORDERINVOICE_ERROR, e)
      })
    })
  },
  getOrderInvoiceDetail ({commit}, orderId) {
    return new Promise((resolve, reject) => {
      return service.getOrderInvoiceDetail(orderId).then(result => {
        resolve(result)
        commit(ORDERCONSTANT.ORDER_GET_ORDER_INVOICE_DETAIL_SUCCESS, result)
        return result
      }, e => {
        reject(e)
        commit(ORDERCONSTANT.ORDER_GET_ORDER_INVOICE_DETAIL_ERROR, e)
      })
    })
  },
  sendOrderInvoiceEmail ({commit}, orderId) {
    return new Promise((resolve, reject) => {
      return service.sendOrderInvoiceEmail(orderId).then(result => {
        return resolve(result)
      }, e => {
        return reject(e)
      })
    })
  },
  deleteOrder ({commit}, orderId) {
    console.log(orderId)
    return new Promise((resolve, reject) => {
      return service.getOrderDeleteStatus(orderId).then(result => {
        resolve(result)
        commit(ORDERCONSTANT.ORDER_DELETE_SUCCESS, result)
        return result
      }, e => {
        return reject(e)
      })
    })
  },
  getFilmGbCode({ commit }, data) {
    return new Promise((resolve, reject) => {
      return service.getFilmGbCode(data).then(data => {
        if (_.isEmpty(data.data)) {
          resolve(data)
          return data
        }
        resolve(data)
        return data
      }, e => {
        reject(e)
      })
    })
  },

  updateCodeStatus({ commit }, data) {
    return new Promise((resolve, reject) => {
        return service.updateCodeStatus(data).then(result => {
            resolve(result)
            return result
        }, e => {
            reject(e)
        })
    })
  },
    /*yeoman-template-point-1*/
}

